import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Tabs, Tab, Button } from "react-bootstrap";

import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';

import PageTitle from "../../components/common/PageTitle";
import UserDetails from "../../components/user-profile-lite/UserDetails";
import UserAccountDetails from "../../components/user-profile-lite/UserAccountDetails";
import DesignsList from "../../components/user-profile-lite/DesignsList";
import SubscriptionsList from '../../components/user-profile-lite/SubscriptionsList';
import AddSubscription from '../../components/user-profile-lite/AddSubscription';

import { userActions, planActions } from '../../actions';

const UserProfile = () => {
  const history = useHistory();
  const { _userId } = useParams();
  const dispatch = useDispatch();
  const user = useSelector(state => state.user.user);
  const loading = useSelector(state => state.user.loading);
  const error = useSelector(state => state.user.error);
  const designs = useSelector(state => state.user.designs);
  const subscriptions = useSelector(state => state.subscription.subscriptions);
  const [activeTab, setActiveTab] = useState()

  useEffect(() => {
    dispatch(planActions.getAll());
    dispatch(userActions.getUser(_userId));
  }, [_userId, dispatch])
  useEffect(() => {
    if (activeTab !== 'designs') return;
    dispatch(userActions.getDesigns(_userId));
  }, [_userId, activeTab, dispatch])


  return (
    <Container fluid className="main-content-container px-4">
      <Row noGutters className="page-header py-4">
        <PageTitle title="User Details" subtitle="Users" className="ml-sm-auto mr-sm-auto" />
        <Col className="headerButtonHolder">
          {activeTab === 'subscriptions' && <AddSubscription userId={_.get(user, '_id')} />}
          <Button className="" variant="danger" onClick={() => history.push(`/users-list`)}><i className="material-icons"></i> Back</Button>
        </Col>
      </Row>
      {error && !user && (
        <div className="alert alert-danger d-flex justify-content-between align-items-center" role="alert">
          <span>{error.error || error.message || error}</span>
          <Button variant="outline-danger" size="sm" onClick={() => dispatch(userActions.getUser(_userId))}>
            Retry
          </Button>
        </div>
      )}
      {loading && !user && <div className="text-center py-5">Loading user...</div>}
      {user && <Tabs defaultActiveKey="details" id="uncontrolled-tab-example" onSelect={(eventKey) => setActiveTab(eventKey)}>
        <Tab eventKey="details" title="Details">
          <Row>
            <Col lg="4">
              <UserDetails user={user} />
            </Col>
            <Col lg="8">
              <UserAccountDetails user={user} />
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="subscriptions" title="Subscriptions">
          <Row>
            <Col>
              <SubscriptionsList data={subscriptions} />
            </Col>
          </Row>
        </Tab>
        <Tab eventKey="designs" title="Designs">
          <Row>
            <Col>
              <DesignsList data={designs} />
            </Col>
          </Row>
        </Tab>
      </Tabs>}
    </Container >
  )
}

export default UserProfile;
